/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-chevron-up': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 6.25l6.25 6.25-.875.875L10 8l-5.375 5.375-.875-.875z"/>'
  }
})
